import { fulfillmentApi } from '../../../api/fulfillmentApi';
import { createMaterial, IMaterial, IMaterialsPerSubActivity } from '../../../models/materials';
import { ITransaction } from '../../../models/transactions/transaction';
import { AppDispatch, RootState } from '../../store';
import { errorSaving, reset, setMaterial, setMaterials, setMaterialsPerSubActivity, setTempMaterialsPerSubActivity, startLoadingMaterials, updateMaterials } from './materialsSlice';

export const getMaterials = (entity: string, idParent?: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingMaterials());

        let resp;
        switch (entity) {
            case "materials":
                resp = await fulfillmentApi.get(`materials`);
                break;
            case "subActivities":
                resp = await fulfillmentApi.get(`materialsPerSubActivity/${idParent}`);
                break;
            case "groups":
                resp = await fulfillmentApi.get(`materialsPerGroup/${idParent}`);
                break;
            case "courses":
                resp = await fulfillmentApi.get(`materialsPerCourse/${idParent}`);
                break;
        }

        dispatch(setMaterials({ materials: resp?.data }));
    }
}

export const saveMaterial = (material: IMaterial) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingMaterials());

        material.bottomSizeId = !material.bottomSizeId || material.bottomSizeId?.toString() === "" ? undefined : material.bottomSizeId;
        material.topSizeId = !material.topSizeId || material.topSizeId?.toString() === "" ? undefined : material.topSizeId;

        const newMaterial = createMaterial(material);
        const resp = await fulfillmentApi.post(`materials`, newMaterial);

        const state = getState();
        let materials = [...state.materials.materials];
        materials.push(resp.data);

        dispatch(setMaterials({ materials }));
    }
}

export const editMaterial = (material: IMaterial) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingMaterials());

        material.bottomSizeId = !material.bottomSizeId || material.bottomSizeId?.toString() === "" ? undefined : material.bottomSizeId;
        material.topSizeId = !material.topSizeId || material.topSizeId?.toString() === "" ? undefined : material.topSizeId;

        await fulfillmentApi.put(`materials/${material.id}`, material);
        const resp = await fulfillmentApi.get(`materials/${material.id}`);

        dispatch(setMaterial({ material: resp.data }));
        dispatch(updateMaterials({ material: resp.data }));
    }
}

export const resetError = () => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(reset());
    }
}
export const adjustMaterialInventory = (transaction: ITransaction) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingMaterials());

        await fulfillmentApi.put(`materials/adjustment/${transaction.materialId}`, transaction)
            .then(async function () {
                const resp = await fulfillmentApi.get(`materials/${transaction.materialId}`);

                dispatch(setMaterial({ material: resp.data }));
                dispatch(updateMaterials({ material: resp.data }));
            }).catch(function (error) {
                //Ejemplo para manejar los errores
                // if (error.response) {
                //     // La respuesta fue hecha y el servidor respondió con un código de estado
                //     // que esta fuera del rango de 2xx
                //     console.log(error.response.data);
                //     console.log(error.response.status);
                //     console.log(error.response.headers);
                // } else if (error.request) {
                //     // La petición fue hecha pero no se recibió respuesta
                //     // `error.request` es una instancia de XMLHttpRequest en el navegador y una instancia de
                //     // http.ClientRequest en node.js
                //     console.log(error.request);
                // } else {
                //     // Algo paso al preparar la petición que lanzo un Error
                //     console.log('Error', error.message);
                // }
                //console.log(error.config);
                dispatch(errorSaving({ error: error.response.data }));
            });
    }
}

export const deleteMaterial = (material: IMaterial) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingMaterials());
        await fulfillmentApi.delete(`materials/${material.id}`);

        const state = getState();
        let materials = [...state.materials.materials];
        materials = materials.filter((item) => item.id !== material.id);

        dispatch(setMaterials({ materials }));
    }
}

export const addMaterial = (materialId: number, entity: string, idParent: string, quantity?: number) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingMaterials());

        let resp;
        switch (entity) {
            case "subActivities":
                await fulfillmentApi.post(`materialsPerSubActivity/${idParent}?materialId=${materialId}&quantity=${quantity}`);
                resp = await fulfillmentApi.get(`materialsPerSubActivity/${idParent}`);
                break;
            case "groups":
                await fulfillmentApi.post(`materialsPerGroup/${idParent}?materialId=${materialId}&quantity=${quantity}`);
                resp = await fulfillmentApi.get(`materialsPerGroup/${idParent}`);
                break;
            case "courses":
                await fulfillmentApi.post(`materialsPerCourse/${idParent}?materialId=${materialId}&quantity=${quantity}`);
                resp = await fulfillmentApi.get(`materialsPerCourse/${idParent}`);
                break;
        }

        dispatch(setMaterials({ materials: resp?.data }));
    }
}

export const removeMaterial = (materialId: number, entity: string, idParent: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingMaterials());

        let resp;
        switch (entity) {
            case "subActivities":
                await fulfillmentApi.delete(`materialsPerSubActivity/${idParent}?materialId=${materialId}`);
                resp = await fulfillmentApi.get(`materialsPerSubActivity/${idParent}`);
                break;
            case "groups":
                await fulfillmentApi.delete(`materialsPerGroup/${idParent}?materialId=${materialId}`);
                resp = await fulfillmentApi.get(`materialsPerGroup/${idParent}`);
                break;
            case "courses":
                await fulfillmentApi.delete(`materialsPerCourse/${idParent}?materialId=${materialId}`);
                resp = await fulfillmentApi.get(`materialsPerCourse/${idParent}`);
                break;
        }

        dispatch(setMaterials({ materials: resp?.data }));
    }
}

export const getMaterialsPerSubActivity = (idSubActivity: number) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingMaterials());

        const resp = await fulfillmentApi.get(`materials/subactivity/${idSubActivity}`);
        const materialsPerSubActivity: IMaterialsPerSubActivity[] = resp.data;

        const materialsPerSubActivityBase: IMaterialsPerSubActivity[] = materialsPerSubActivity.map((material) => ({ ...material }));

        dispatch(setMaterialsPerSubActivity({ materialsPerSubActivity, materialsPerSubActivityBase }));
    }
}

export const getTempMaterialsPerSubActivity = (tempMaterialsPerSubActivity: IMaterialsPerSubActivity[], selectedIdMaterialsPerSubActivity: number[]) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {

        dispatch(setTempMaterialsPerSubActivity({ tempMaterialsPerSubActivity, selectedIdMaterialsPerSubActivity }));
    }
}